<template>
  <v-app>
    <Def>
      <v-container fluid style="margin-top:100px;">
        <v-row>
          <v-col cols="2" class="pa-0">
            <Bt :token="$store.state.polz" :toggle_exclusive="4" />
          </v-col>
          <v-col cols="7" class="ml-12 mt-n5">
            <v-row class="mt-n3">
              <v-list-item>
                <v-list-item-avatar size="80" color="grey lighten-1"></v-list-item-avatar>
                <v-list-item-content>
                  <v-col class="pa-0">
                    <v-row class="ma-0 headline mt-n4">{{items.Name}}</v-row>
                    <v-row class="ma-0 pt-3">
                      <div v-if="items.Data != 'В сети'">Пользователь был в сети - {{items.Data}}</div>
                      <div v-else>
                        Пользователь - {{items.Data}}
                        <v-avatar class="ml-3" color="green" size="18"></v-avatar>
                      </div>
                    </v-row>
                  </v-col>
                </v-list-item-content>
              </v-list-item>
            </v-row>
            <v-row class="pt-3">
              <v-card
                class="rounded-lg pa-3"
                outlined
                height="46em"
                style="border: 2px #5B98F1 solid"
                width="100%"
              >
                <v-row>
                  <v-responsive ref="resp" class="overflow-y-auto" height="40em">
                    <v-main>
                      <v-card v-for="item in itemss" :key="item.idm" tile elevation="0">
                        <v-main v-if="item.id" class="pl-4">
                          <v-card-title class="headers" v-if="item.name">{{items.Name}}</v-card-title>
                          <v-row class="ma-0">
                            <v-col cols="8" class="pt-0">
                              <v-card rounded color="grey lighten-3" outlined class="rounded-lg">
                                <v-card-title>{{item.subtitle}}</v-card-title>
                              </v-card>
                            </v-col>
                            <v-col cols="4">
                              <v-spacer></v-spacer>
                            </v-col>
                          </v-row>
                        </v-main>

                        <v-main v-else>
                          <v-card-title
                            class="headers d-flex justify-end"
                            v-if="item.name"
                          >{{Fio}}</v-card-title>

                          <v-row class="ma-0">
                            <v-col cols="4">
                              <v-spacer></v-spacer>
                            </v-col>
                            <v-col cols="8" class="pt-0">
                              <v-card rounded color="grey lighten-3" outlined class="rounded-lg">
                                <v-card-title>{{item.subtitle}}</v-card-title>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-main>
                      </v-card>
                    </v-main>
                  </v-responsive>
                </v-row>
                <v-row>
                  <v-col cols="10" class="px-5 pt-5">
                    <v-textarea
                      filled
                      outlined
                      v-model="Mes"
                      rows="1"
                      no-resize
                      dense
                      rounded
                      :append-icon="show ? 'add_circle_outline' : 'create'"
                      @click:append="req()"
                      @keypress="shows()"
                      @keypress.enter="enter()"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      depressed
                      class="rounded-xl mt-2 text-capitalize"
                      outlined
                      color="orange"
                      width="100%"
                      @click="enter()"
                    >
                      <div class="black--text">Отправить</div>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-row>
          </v-col>
          <v-col cols="2" class="pt-0 pl-12 ml-8">
            <Bt2 />
          </v-col>
        </v-row>
      </v-container>
    </Def>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    items: {
      Name: null,
      Data: null,
    },
    Divid: {
      divider: true,
    },
    show: true,
    Mes: null,
    itemss: [
      {
        name: true,
        id: 1,
        idm: 1,
        subtitle:
          "В старт 1,нужно будет заполнять смету, как и везде, нужно определить ряд издержек, на которые будет тратить финансы. Например аренда хостинга, аренда офиса, техническое сопровождение, юридическое сопровождение, закупка оборудования ",
      },
      {
        name: true,
        idm: 2,
        subtitle: "1 сообщение",
      },
      {
        name: true,
        id: 1,
        idm: 3,
        subtitle:
          "Главное не перегори, нырнуть с головой хорошо, но надо размеренно, чтобы был комфорт от работы, а не какая то принужденность",
      },
      {
        name: true,
        idm: 4,
        subtitle: "2 сообщение",
      },
    ],
  }),
  created() {
    setTimeout(() => {
      var sc = this.$refs.resp._self.$el;
      sc.scrollTop = sc.scrollHeight;
    }, 50);
    if (this.$route.params.e == 1) {
      this.items.Name = "Хайруллина Фарида";
      this.items.Data = "в 21.13";
    } else if (this.$route.params.e == 2) {
      this.items.Name = "Татнефть";
      this.items.Data = "вчера";
    } else {
      this.items.Name = "КГЭУ";
      this.items.Data = "В сети";
    }
    if(this.$ls.get("inAk") == undefined){
      this.$router.replace("/")
    }
  },
  methods: {
    shows() {
      if (this.Mes == null || this.Mes == "" || this.Mes == undefined) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    enter() {
      if (this.itemss[this.itemss.length - 1].id != 1) {
        this.itemss.push({
          idm: this.itemss.length + 1,
          subtitle: this.Mes,
        });
      } else {
        this.itemss.push({
          name: true,
          idm: this.itemss.length + 1,
          subtitle: this.Mes,
        });
      }
      this.show = true;
      setTimeout(() => {
        this.Mes = undefined;
        var sc = this.$refs.resp._self.$el;
        sc.scrollTop = sc.scrollHeight;
      }, 50);
    },
    req() {
      if (this.itemss[this.itemss.length - 1].id == 1) {
        this.itemss.push({
          id: 1,
          idm: this.itemss.length + 1,
          subtitle: "Привет",
        });
      } else {
        this.itemss.push({
          name: true,
          id: 1,
          idm: this.itemss.length + 1,
          subtitle: "Привет",
        });
      }
      setTimeout(() => {
        var sc = this.$refs.resp._self.$el;
        sc.scrollTop = sc.scrollHeight;
      }, 50);
    },
  },
  computed:{
    Fio(){
      var a = this.$ls.get("fio").split("_");
      return a[0] + ' ' + a[1];
    }
  }
};
</script>